module.exports = __webpack_public_path__ + "static/media/view6.ee02f373.jpg";